import KunLoading29 from './src/index'

KunLoading29.install = function (Vue) {
	Vue.component(KunLoading29.name, KunLoading29);
}

export default KunLoading29;
